import { useMemo } from 'react';
import { DOCUMENT_TYPES, DOCUMENT_TYPE_ORDER } from './DocumentTypeConfig';

/**
 * Hook that computes document counts for all types from project data.
 * Returns a map of { docTypeKey: count }
 */
export default function useDocumentCounts(projectData) {
  return useMemo(() => {
    const counts = {};
    DOCUMENT_TYPE_ORDER.forEach((key) => {
      const config = DOCUMENT_TYPES[key];
      const docs = projectData?.[config.firestoreKey];
      counts[key] = Array.isArray(docs) ? docs.length : 0;
    });
    return counts;
  }, [projectData]);
}
